import React, { useEffect, useState } from "react";
import { Constants } from "../../../CommonMethhods/Constants";
import Loader from "../../../Components/Common/Loader";
import SmallLoader from "../../../Components/Common/smallLoader";
import MorningLimitsTable from "../../../Components/ReportTables/MorningLimitsTable";
import { Dashboard_Client_Report } from "../../../Configuration/API_URL";
import { Col, Row, Toast } from "react-bootstrap";
import { toast } from "react-toastify";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function MorningLimitReportNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const [fileType, setFileType] = useState("grid");
  const [data, setData] = useState("");
  const [loader, setLoader] = useState(false);
  const [smallLoaderMail, setSmallLoaderMail] = useState(false);
  const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
  const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
  const [serverError, setServerError] = useState(false);
  const ClientId2 = localStorage.getItem("ClientId2");
  const [errorGrid, setErrorGrid] = useState(false);

  let clientCode = "";

  const getMorningLimitReport = async (clientCode) => {
    setLoader(true);
    if (fileType == "excel") {
      setSmallLoaderExcel(true);
      setSmallLoaderPdf(false);
      setSmallLoaderMail(false);
      setLoader(false);
    } else if (fileType == "pdf") {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(true);
      setLoader(false);
    } else if (fileType == "mail") {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(true);
      setSmallLoaderPdf(false);
      setLoader(false);
    } else {
      setSmallLoaderExcel(false);
      setSmallLoaderMail(false);
      setSmallLoaderPdf(false);
    }
    let payloadValue = {
      clientCode: clientCode || ClientId2,
      fileType: fileType,
      seg: "stocks",
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetails = await axiosInstance.post(
        Dashboard_Client_Report.MorningLimitReport_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetails?.data);
      if(res?.status === 0){
        if (fileType == "grid") {
          setData(res?.data);
        } else if (fileType == "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        } else if (fileType == "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        } else if (fileType == "mail") {
          toast.success("Mail sent successfully");
        }
      } else {
        setData([]);
        
        if (fileType == "excel") {
          toast.error("Morning Limit Report does not exist");
        } else if (fileType == "pdf") {
          toast.error("Morning Limit Report does not exist");
        } else if (fileType == "mail") {
          toast.error("Morning Limit Report does not exist");
        } else if (fileType == "grid") { 
          setErrorGrid(res?.message);
        }
      }
      setLoader(false);
      setSmallLoaderMail(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
      setSmallLoaderMail(false);
      setSmallLoaderExcel(false);
      setSmallLoaderPdf(false);
      setServerError(error?.message);
      if (fileType == "excel") {
        toast.error(error?.message);
      }
      if (fileType == "pdf") {
        toast.error(error?.message);
      }
      if (fileType == "mail") {
        toast.error(error?.message);
      }
    }
  };
  useEffect(() => {
    if (localStorage.getItem("clientCode") || ClientId2) {
      clientCode = localStorage.getItem("clientCode");
      getMorningLimitReport(clientCode);
    }
  }, [fileType]);

  const handleOnClick = (e) => {
    setFileType("");
    setServerError("");
    if (e.target.value) {
      setFileType(e.target.value);
    }
  };


  return (
    <>
      <div
        className="tab-pane fade show active"
        id="morning-limit"
        role="tabpanel"
        aria-labelledby="morning-limit"
      >
        <div className="reports-date-filter">
          <button
            className="generate-button mail-btn"
            value="mail"
            onClick={handleOnClick}
          >
            {smallLoaderMail ? (
              // <div>
              <SmallLoader />
            ) : (
              <>
                <span className="icon-email"></span>
                E-Mail
              </>
            )}
          </button>

          <button
            className="generate-button excel-btn"
            value="excel"
            onClick={handleOnClick}
          >
            {smallLoaderExcel ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-excelsvg"></span>
                {Constants.Excel}
              </>
            )}
          </button>
          <button
            className="generate-button pdf-btn"
            value="pdf"
            onClick={handleOnClick}
          >
            {smallLoaderPdf ? (
              <div>
                <SmallLoader />
              </div>
            ) : (
              <>
                <span className="icon-pdfsvg"></span>
                {Constants.PDF}
              </>
            )}
          </button>
        </div>
      </div>
      {loader ? (
        <div className="loader-alignment">
          <Loader />
        </div>
      ) : data ? (
        <div>
          <MorningLimitsTable data={data} />
        </div>
      ) : serverError ? (
        <h4 className="report-table-wrapper">{noDataFound(serverError)}</h4>
      ) : errorGrid ? (
        noDataFound(errorGrid)
      ) : (
        ""
      )}
    </>
  );
}
export default MorningLimitReportNew;
